import facebookCommentsActions from 'actions/facebookCommentsActions';
import lazyLoadActions from 'actions/lazyLoadActions'
import analyticsActions from 'actions/analyticsActions';
import { BaseStore } from 'stores/baseStore';
import scrollTo from 'scroll-to-element';
import pageDataObject from 'application/pageDataObject';
import { makeSafeFn, } from 'utils/fn';
import { isNativeApp, } from 'utils/ua';
import LazyLoadService from 'services/LazyLoadService';
import { getSingleElementByClass, } from 'utils/dom';

const FACEBOOK_COMMENTS_CONFIG = {
  NEW_COMMENT_EVENT: 'comment.create',
  INITIAL_LOADED_LAYOUTS: ['hybrid', 'native']
};


class FacebookCommentsStore extends BaseStore {

  constructor(options){
    super(options);
    this.isFacebookCommentsShown = false;
    this.loadTriggerElement = getSingleElementByClass('facebook-comments-load-trigger');
    if (this.loadTriggerElement){
      LazyLoadService.create({ loadTriggerElement: this.loadTriggerElement });
    }
  }

  routeAction(action) {
    let ACTIONS = facebookCommentsActions.TYPES;
    switch (action.type) {
      case ACTIONS.SCROLL_TO:
        return this.scrollToFacebookComments(action.scrollingEventObject);
      case ACTIONS.LOAD:
        return this.loadFacebookComments(action.facebookConfig);
      case ACTIONS.LOADED:
        return this.facebookCommentsLoaded();
      case lazyLoadActions.TYPES.REACHED_LOAD_TARGET:
        return this.loadOnScrollToElement(action);
      default:
        return this;
    }
  }

  get isFacebookCommentsShown() { return this.state.isFacebookCommentsShown || false; }
  set isFacebookCommentsShown(bool) { this.state.isFacebookCommentsShown = bool; }

  get isFacebookCommentsLoaded() { return this.state.isFacebookCommentsLoaded || false; }
  set isFacebookCommentsLoaded(bool) { this.state.isFacebookCommentsLoaded = bool }

  get shouldLoadCommentsOnStart() { return isNativeApp; }


  scrollToFacebookComments(scrollingEventObject){
    let { scrollToElementSelector, offset, ease, duration } = scrollingEventObject;
    scrollTo(scrollToElementSelector, { offset, ease, duration });
  }

  loadFacebookComments(facebookConfig){
    this.isFacebookCommentsShown = true;
    this.emitChange();
    return this;
  }

  loadOnScrollToElement(action){
    let layout = pageDataObject.get('post.layout');
    if (action.scrollingEventObject.element === this.loadTriggerElement && FACEBOOK_COMMENTS_CONFIG.INITIAL_LOADED_LAYOUTS.includes(layout)){
      this.loadFacebookComments(action.facebookConfig);
    }
  }

  subscribeToFacebookCommentsEvent(){
    makeSafeFn(window.FB.Event.subscribe(FACEBOOK_COMMENTS_CONFIG.NEW_COMMENT_EVENT, analyticsActions.facebookCommentAdded));
  }

  facebookCommentsLoaded(){
    window.FB.XFBML.parse();
    this.subscribeToFacebookCommentsEvent();
    this.isFacebookCommentsLoaded = true;
    this.emitChange();
    return this;
  }
}

let facebookCommentsStore = FacebookCommentsStore.create();

export default facebookCommentsStore;


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/facebookCommentsStore.js